export default __webpack_public_path__ + "static/media/img-0639-north-macedonia-full-face.4393a7a6.png";